import defaultRoutes from './default/routes'

const routes = [
  ...defaultRoutes
]

export default routes
